import React from 'react';
import { Arrow, Layer, Rect, Text } from 'react-konva';
import { KonvaImage } from "./image";
import { Colors } from '../configs/colors';

export const HallOne = () => {
    const wallColor = Colors.WALL;
    const wallColorBrown = Colors.WALLDARK;
    const doorColor = Colors.DOORS;
    const colorBlue = '#0ea2ff'; // Rote Farbe für die Türen
    const colorRed = '#de2727'; // Rote Farbe für die Türen
    const colorYellow = '#fff600'; // Rote Farbe für die Türen
    const colorBrown = '#7a5235'; // Rote Farbe für die Türen
    const colorWhite = '#ffffff'; // Rote Farbe für die Türen

    return (
        <Layer>
            {/* Wände */}
            {/*<Rect x={-580} y={70} width={1065} height={440} fill={wallColor} /> */}

            {/* Türen
            <KonvaImage x={200} y={100} width={50} height={30} src={"exit.png"} />
            <KonvaImage x={300} y={100} width={50} height={30} src={"exit.png"} />
            <KonvaImage x={400} y={100} width={50} height={30} src={"exit.png"} />
            <KonvaImage x={500} y={100} width={50} height={30} src={"exit.png"} />
            <KonvaImage x={707} y={138} width={30} height={20} src={"exit.png"} />*/}

            {/*
            <Arrow x={225} y={70} points={[0,30, 0, 0]} fill={"brown"} stroke={"brown"} strokeWidth={15} />
            <Arrow x={325} y={70} points={[0,30, 0, 0]} fill={"brown"} stroke={"brown"} strokeWidth={15} />
            <Arrow x={425} y={70} points={[0,30, 0, 0]} fill={"brown"} stroke={"brown"} strokeWidth={15} />
            <Arrow x={525} y={70} points={[0,30, 0, 0]} fill={"brown"} stroke={"brown"} strokeWidth={15} />

            <Arrow x={300} y={385} points={[100,0, 0, 0]} fill={"black"} stroke={"black"} />
            <Arrow x={550} y={385} points={[100,0, 0, 0]} fill={"black"} stroke={"black"} />
            <Arrow x={550} y={200} points={[0,0, 100, 0]} fill={"black"} stroke={"black"} />
            <Arrow x={300} y={200} points={[0,0, 100, 0]} fill={"black"} stroke={"black"} />
            <Arrow x={200} y={250} points={[0,100, 0, 0]} fill={"black"} stroke={"black"} />
            <Arrow x={715} y={250} points={[0,0, 0, 100]} fill={"black"} stroke={"black"} />*/}


            {/* Catering Background */}
            <Rect x={715} y={70} width={225} height={225} fill={wallColorBrown} />

            {/* Wall of Fame Colors */}
            <Rect x={720} y={295} width={30} height={15} fill={colorBlue} />
            <Rect x={751} y={295} width={30} height={15} fill={colorRed} />
            <Rect x={782} y={295} width={30} height={15} fill={doorColor} />
            <Rect x={813} y={295} width={30} height={15} fill={colorYellow} />
            <Text x={740} y={312} text="Wall of Fame" fontSize={15} />
            <KonvaImage x={720} y={180} width={50} height={50} src={"wc.png"} />
            <KonvaImage x={720} y={230} width={50} height={50} src={"wc.png"} />
            <Text x={893} y={205} text="CATERING" fontSize={25} fill={colorWhite} rotationDeg={270} />



            <Rect x={867} y={285} width={73} height={10} fill={wallColor} />
            <Rect x={872} y={275} width={63} height={10} fill={wallColor} />
            <Rect x={877} y={265} width={53} height={10} fill={wallColor} />
            <Rect x={882} y={255} width={43} height={10} fill={wallColor} />
            <Rect x={887} y={245} width={33} height={10} fill={wallColor} />
            <Rect x={892} y={235} width={23} height={10} fill={wallColor} />

            <Arrow x={903} y={215} points={[0,80, 0, 0]} fill={"black"} stroke={"black"} />



        </Layer>
    );
};
